module.exports = __webpack_public_path__ + "static/media/liquid-icon.6446f1c5.png";